import { useQuery } from '@tanstack/react-query'
import { httpClientPrivate } from '@/libs/httpClient'
import { PartnerCanDeleteResponse } from './types'
import config from '@/config'

const fetchPartnerCanDelete = async (partnerId: string): Promise<PartnerCanDeleteResponse> => {
  const response = await httpClientPrivate.get(
    `${config.restUrl}/v1/active-health-partner/${partnerId}/can-delete`,
  )

  return response.data
}

const usePartnerCanDelete = (partnerId?: string, enabled: boolean = false) => {
  const query = useQuery<PartnerCanDeleteResponse>({
    queryKey: ['usePartnerCanDelete', partnerId],
    queryFn: async () => fetchPartnerCanDelete(partnerId as string),
    enabled: !!partnerId && enabled,
  })

  return query
}

export { usePartnerCanDelete, fetchPartnerCanDelete }
